import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/leave-management-system/leave-requests/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "leave-requests" entry is kept); the seo block below is a fallback.

export const leaveRequests: ContentPage = {
  slug: "leave-management-system/leave-requests",
  template: "hrmsFeature",
  seo: {
    title: "Leave Request Management System - Automate Leave Approvals",
    description: "Easily submit and approve employee leave requests with automated workflows and real-time tracking. Simplify your HR processes with our Leave Request system.",
    keywords: [
      "leave request management",
      "employee leave requests",
      "leave approval process",
      "HR leave request system",
      "automated leave workflow",
      "leave tracking software",
    ],
    ogImage: "/assets/data/seoimages/leave-requests.webp",
  },
  leaf: {
    hero: {
      caption: "Leave Requests",
      title: "Streamline Employee Leave Requests with Automated Workflows",
      description: "Simplify the leave request process with automated workflows that allow employees to submit requests quickly and managers to approve or decline with ease.",
      h1: "caption",
    },
    split: {
      title: "Effortless Leave Handling for Enhanced Workflow Efficiency",
      bullets: [
        { title: "Self-Service Requests", description: "Employees use the dashboard to select leave types and details." },
        { title: "Automated Approvals", description: "Customize routes for manager approvals and automate the process." },
        { title: "Real-Time Alerts", description: "Receive updates on request submissions and approval statuses." },
        { title: "Request History", description: "Track all leave requests, including dates and approval statuses." },
      ],
      image: "/assets/images/img/product/hrms/leavems/leave-requests_info.webp",
      imageAlt: "leave-requests",
    },
    cardsHeading: {
      title: "Key Features of Leave Management System",
      description: "Optimize leave management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Leave Policy & Allocation",
        href: "/hrms-software/leave-management-system/leave-policy-allocation",
        description: "Create and manage leave policies tailored to your organization’s needs. Allocate leaves based on roles, seniority, and more.",
        image: "/assets/images/img/product/hrms/leavems/leave_policy_and_allocation.webp",
        imageAlt: "leave_policy_and_allocation",
      },
      {
        title: "Leave Balance",
        href: "/hrms-software/leave-management-system/leave-balance",
        description: "Keep track of employee leave balances in real-time, ensuring transparency and accurate record-keeping.",
        image: "/assets/images/img/product/hrms/leavems/leave_balance_features.webp",
        imageAlt: "leave_balance",
      },
      {
        title: "Easy Approval",
        href: "/hrms-software/leave-management-system/leave-approval/",
        description: "Facilitate quick and easy leave request approvals or declines with a user-friendly workflow, keeping your HR processes efficient.",
        image: "/assets/images/img/product/hrms/leavems/easy_approval_decline.webp",
        imageAlt: "easy_approval",
      },
      {
        title: "Leave History",
        href: "/hrms-software/leave-management-system/leave-history",
        description: "Access detailed records of all past leaves, ensuring transparency and easy reference for both employees and HR managers.",
        image: "/assets/images/img/product/hrms/leavems/leave_history.webp",
        imageAlt: "leave_history ",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Automate Your Leave Request Process",
    relatedBlogsKeyword: "leave-management-software-sme",
    metaKey: "leave-requests",
  },
  sections: [],
};
